<div>
    <header class="flex flex-col flex-start md:flex-row justify-between md:items-center mt-4 pb-6 mx-8">
        <div>
            <span class="font-display font-medium text-2xl">
                {{ 'my_claims.title' | translate }}
            </span>
        </div>
        <div class="relative mt-6 md:mt-0 w-100">
            <app-input
                (valueChanged)="filterSearch($event, false)"
                (enterPressed)="filterSearch($event, true)"
                [value]="search"
                placeholder="{{ 'global.search_input_placeholder' | translate }}"
                class="h-10 w-100 w-full md:w-[200px]"
                [block]="true"
            />

            <div class="absolute top-0 bottom-0 right-0 flex flex-col justify-center p-2 cursor-pointer" (click)="fetchClaims()">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path
                        d="M19.9758 21.0762L13.7258 14.8262C13.2258 15.2428 12.6508 15.5678 12.0008 15.8012C11.3508 16.0345 10.7008 16.1512 10.0508 16.1512C8.43411 16.1512 7.07178 15.5968 5.96378 14.4882C4.85511 13.3802 4.30078 12.0262 4.30078 10.4262C4.30078 8.82617 4.85511 7.47184 5.96378 6.36317C7.07178 5.25517 8.42578 4.70117 10.0258 4.70117C11.6258 4.70117 12.9841 5.25517 14.1008 6.36317C15.2174 7.47184 15.7758 8.82617 15.7758 10.4262C15.7758 11.1262 15.6508 11.8012 15.4008 12.4512C15.1508 13.1012 14.8258 13.6512 14.4258 14.1012L20.7008 20.3762L19.9758 21.0762ZM10.0508 15.1512C11.3674 15.1512 12.4841 14.6972 13.4008 13.7892C14.3174 12.8805 14.7758 11.7595 14.7758 10.4262C14.7758 9.09284 14.3174 7.97184 13.4008 7.06317C12.4841 6.15517 11.3674 5.70117 10.0508 5.70117C8.71745 5.70117 7.59245 6.15517 6.67578 7.06317C5.75911 7.97184 5.30078 9.09284 5.30078 10.4262C5.30078 11.7595 5.75911 12.8805 6.67578 13.7892C7.59245 14.6972 8.71745 15.1512 10.0508 15.1512Z"
                        fill="#232323"
                    />
                </svg>
            </div>
        </div>
    </header>
    <div class="cosentino-tab">
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: !this.status }" (click)="filterClaims(null)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.all' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.status == 'DRAFT' }" gtm-label="filter_draft" (click)="filterClaims('DRAFT')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.draft' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.status == 'IN_REVIEW' }" gtm-label="filter_in-review" (click)="filterClaims('IN_REVIEW')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.review' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.status == 'APPROVED' }" gtm-label="filter_approved" (click)="filterClaims('APPROVED')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span class="">{{ 'my_claims.approved' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.status == 'DENIED' }" gtm-label="filter_denied" (click)="filterClaims('DENIED')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.denied' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.status == 'CLOSED' }" gtm-label="filter_closed" (click)="filterClaims('CLOSED')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.closed' | translate }}</span>
                </div>
            </div>
        </a>
    </div>
    <div class="content">
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
            <!-- 🧾 Contenido principal -->
            <!-- 🧾 Contenido principal -->
            <div class="order-2 md:order-1 md:col-span-9 w-full">
                <!-- Aquí sí puedes tener un grid si necesitas dividir más elementos -->
                <div class="projects grid gap-4 w-full">
                    <ng-container *ngFor="let claim of claims">
                        <app-claim-card [claim]="claim" (onClaimDelete)="fetchClaims()"></app-claim-card>
                    </ng-container>

                    <div *ngIf="shouldShowNextButton()">
                        <app-button [block]="true" (onClick)="nextPage()">
                            {{ 'global.view_more' | translate }}
                        </app-button>
                    </div>
                    <div *ngIf="claims && claims.length == 0" class="empty-container flex justify-center">
                        <div class="empty-title typography-title-l">{{ 'my_claims.no_claims_here' | translate }}</div>
                        <div>
                            <div class="empty-button">
                                <app-button [primary]="true" [disabled]="false" [block]="true" [class]="'py-3 px-6'" (onClick)="goToCreateClaim()"
                                    >{{ 'create-claim.register_new_claim' | translate }}
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 📌 Sidebar New Claim -->
            <div class="order-1 md:order-2 md:col-span-3">
                <app-new-claim></app-new-claim>
            </div>
        </div>
    </div>
</div>
